<div class="percentage" [ngClass]="{'negative': displayValue < 0, 'positive': displayValue > 0}">
  <span *ngIf="displayValue > 999">>999%</span>
  <span *ngIf="displayValue <= 999">{{displayValue < -999 ? '<-999' : displayValue}}%</span>  
</div>
